import UserCreate from "./UserCreate";
import UserEdit from "./UserEdit";
import UserList from "./UserList";
import UserShow from "./UserShow";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";

export const users = {
  list: UserList,
  show: UserShow,
  edit: UserEdit,
  create: UserCreate,
  icon: ManageAccountsIcon,
  options: { label: "ra.users.title" },
};
